import { useEffect, useRef } from 'react';
import atmosphere from 'atmosphere.js';

const useWebSocket = (userHash, updateLocations, apiUserInfo) => {
  const subSocket = useRef(null);

  const { type, status, expirationDate } = apiUserInfo;

  useEffect(() => {
    if (!userHash || apiUserInfo.type !== 'user') return;

    const { status, expirationDate } = apiUserInfo;

    // Convertir "DD/MM/YYYY" a formato Date en JavaScript
    if (expirationDate) {
      const [day, month, year] = expirationDate.split("/").map(Number);
      const expiration = new Date(year, month - 1, day, 23, 59, 59); // Meses en JS van de 0 a 11

      if (status !== 'activo' || expiration < new Date()) {
        return;
      }
    }

    const sendSubscribeRequest = () => {
      // console.log('sending subscribe action to websocket');
      subSocket.current.push(
        JSON.stringify({
          action: 'subscribe',
          hash: userHash,
          requests: [
            {
              type: 'state_batch',
              target: { type: 'all' }
            }
          ]
        })
      );
    };

    const request = {
      url: 'https://pro.lepton-seguridad.com/api-v2/event/subscription',
      contentType: 'application/json',
      logLevel: 'debug',
      transport: 'websocket',
      trackMessageLength: false,
      reconnectInterval: 2000,
      onOpen: (response) => {
        // console.log('onOpen', response);
        sendSubscribeRequest();
      },
      onReopen: (response) => {
        // console.log('onReopen', response);
        sendSubscribeRequest();
      },
      onMessage: (msg) => {
        try {
          let responseBody = msg.responseBody;

          if (responseBody.startsWith('X')) {
            responseBody = responseBody.substring(1);
          }

          if (responseBody.endsWith('X')) {
            responseBody = responseBody.slice(0, -1);
          }

          const msgData = JSON.parse(responseBody);

          if (msgData.type === 'event') {
            updateLocations(msgData.data);
          }
        } catch (error) {
          console.error('Error parsing websocket message:', msg.responseBody);
        }
      },
      onClientTimeout: (response) => {
        // console.log('onClientTimeout', response);
      },
      onTransportFailure: (errorMsg, request) => {
        // console.log('onTransportFailure', errorMsg);
      },
      onClose: (response) => {
        // console.log('onClose', response);
      },
      onError: (response) => {
        console.log('onError', response);
      },
      onReconnect: (request, response) => {
        // console.log('onReconnect', response);
      }
    };

    // Inicia la conexión WebSocket
    subSocket.current = atmosphere.subscribe(request);

    // Limpia la conexión al desmontar el componente
    return () => {
      if (subSocket.current) {
        subSocket.current.close();
      }
    };
  }, [userHash, type, status, expirationDate]); // `userHash` y 'apiUserInfo' como dependencias para asegurar actualización

};

export default useWebSocket;
